export default require('./PlayButton').default
